module.exports = __webpack_public_path__ + "img/img-loading.51ab97c8.gif";